import styled from "styled-components";
import { ArenaHeaderButtonLabelDefaultBox } from "./arena-header-button-label.default.box";

export const ArenaHeaderButtonLabelCasino888MiniOrbitBox = styled(ArenaHeaderButtonLabelDefaultBox)`
    padding-bottom: 13px;
    margin-top: -10px;
`;